module.exports = __webpack_public_path__ + "img/4-banner_bg.97874cfc.png";